module.exports = __webpack_public_path__ + "static/media/gradientBackgroundGreyCard.165a5abb.png";